type ParamSingleValue = number | string | Date;
type ParamValue = ParamSingleValue | Array<ParamSingleValue> | boolean | undefined;

export type IQueryObject = Record<string, ParamValue>;

export const safeString = (object: ParamValue): any[] | string[] | string | undefined => {
    if (object instanceof Array) {
        object = object.filter(value => !!value);

        return object.length === 0 ?
            undefined :
            object.map(safeString);
    }

    return object != null ? object.toString() : undefined;
};

export const queryBuilder = (parameters: IQueryObject): Record<string, string | string[]> =>
    Object.keys(parameters).reduce((qp: any, key) => {
        const value = safeString(parameters[key]);
        if (!!value) {
            qp[key] = value;
        }
        return qp;
    }, {});
